export default __webpack_public_path__ + "static/skill-dark-228d63646b6232e41a2964bccdb1d88a12594d8565ae9d2fe20b29fabf11c60c.png";